module.exports = __webpack_public_path__ + "img/success.8c3addfd.png";